if (!customElements.get('notification-component')) {
    customElements.define(
      'notification-component',
      class NotificationComponent extends HTMLElement {
        constructor() {
          super();
      
          this.image = this.querySelector('[data-notification-image]');
          this.name = this.querySelector('[data-notification-title]');
          this.info = this.querySelector('[data-notification-info]');
          this.action = this.querySelector('[data-notification-close]');
        }
      
        connectedCallback() {
          this.notificationData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
          this.handle = this.notificationData.handle;
          this.limit = this.notificationData.limit;
          this.local = this.notificationData.local;
          this.time = this.notificationData.time;
          this.timeout = this.notificationData.timeout;
          this.isPause = false;
          if (this.handle != '' && window.innerWidth > 767) {
            this.onShow();
            this.addEventListener('mouseover', event => { 
              this.isPause = true;
              this.classList.add('hover-popup');
            });
            this.addEventListener('mouseleave', event => { 
              this.isPause = false;
              this.classList.remove('hover-popup');
            });
          }
        }
      
        onShow = async () => {
          if (this.data) return;
          this.data = await this._getData();
          let iProduct = getRandomInt(0, this.data['products'].length - 1), 
              iLocal = getRandomInt(0, this.local.length - 1), 
              iTime = getRandomInt(0, this.time.length - 1), 
              iTimeOut = 0,
              isClose = false;
          setTimeout(() => {
            const countDown = setInterval(() => {
              if (window.innerWidth > 767) {
                if (!this.isPause) {
                  if (iTimeOut == 0) {
                    this._addProduct(this.data['products'][iProduct], this.local[iLocal], this.time[iTime]);
                    iProduct = getRandomInt(0, this.data['products'].length - 1);
                    iLocal = getRandomInt(0, this.local.length - 1);
                    iTime = getRandomInt(0, this.time.length - 1);
                    iTimeOut += 1000;
                    isClose = false;
                  } else if (iTimeOut == this.timeout) {
                    this.onSectionHide();
                    isClose = true;
                  }
                  isClose == false ? iTimeOut += 1000 : iTimeOut -= 1000;
                }
              } else {
                this._onRemove(countDown);
              }
            }, 1000);
            this.onClose(countDown);
          }, this.timeout);
        }
      
        onClose(countDown) {
          this.action.addEventListener('click', event => {
            event.preventDefault();
            this._onRemove(countDown);
          });
        }
      
        onSectionShow() {
          this.classList.add('show-popup');
        }
      
        onSectionHide() {
          this.classList.remove('show-popup');
        }
      
        _onRemove(countDown) {
          this.onSectionHide();
          setTimeout(() => {
            this.innerHTML = '';
            clearInterval(countDown);
          }, 1000);
        }
      
        _addProduct(data, local, time) {
          const mediaPrimary = this.querySelector('.ajax-notification__image-primary');
          const newMedia = this._createMediaImg(data['images'][0], mediaPrimary.className, mediaPrimary.sizes);
          if (mediaPrimary) {
            mediaPrimary.replaceWith(newMedia);
          }
          this.image.href = `/products/${data['handle']}`;
          this.name.innerHTML = data['title'];
          this.name.href = `/products/${data['handle']}`;
          this.info.innerHTML = `${time}, ${local}`;
          this.onSectionShow();
        }
      
        _createMediaImg(media, className, sizes) {
          return createMediaImg(media, [50, 75, 100, 150], { class: className, sizes});
        }
        
        _getData() {
          const data = new Promise(async (resolve, reject) => {
            const response = await fetch(`/collections/${this.handle}/products.json?limit=${this.limit}`);
            if (response.ok) {
              const responseAsJson = await response.json();
              resolve(responseAsJson);
            } else {
              reject(`
                Attempted to load information for product with handle ${this.handle}, but this product is in "draft" mode. You won't be able to
                switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
                to "active".
              `);
            }
          });
          return data;
        }
  
        onSectionUnLoad() {
          this.onSectionHide();
        }
  
        onSectionSelect() {
          this.onSectionShow();
        }
  
        onSectionDeselect() {
          this.onSectionHide();
        }
      }
    );
  }
  